import "../css/AboutMeSec.css";
import MyLink from "@mui/material/Link";
import { Card, Divider } from "@mui/material";
import Container from "@mui/material/Container";
import Footer from "../Footer";
import { Link } from "react-router-dom";
// import { useEffect, useState } from "react";
export default function AboutMeSec() {
  return (
    <div
      className="all-footer-ele-container"
      style={{
        width: "100%",
        height: "100vh",
        backgroundColor: "rgb(28, 29, 32)",
        display: "flex",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Container
        maxWidth="md"
        style={{ backgroundColor: "transparent", position: "relative" }}
      >
        <Card
          sx={{ backgroundColor: "transparent" }}
          className="fotter-card"
          style={{
            position: "relative",
            marginBottom: "50px",
            boxShadow: "none",
          }}
        >
          <div
            className="container-of-info"
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            <h1
              className="lets-work-together"
              style={{
                display: "flex",
                flexDirection: "column",
                fontWeight: "500",
                fontSize: "70px",
                color: "white",
              }}
            >
              <span
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <div className="my-image"></div>
                <span>Let's Work</span>
              </span>
              <span>Together</span>
            </h1>
            <div>
              <Link to="/contact">
                <button
                  className="call-me-btn"
                  style={{
                    width: "200px",
                    height: "200px",
                    border: "none",
                    borderRadius: "50%",
                    backgroundColor: "white",
                    color: "black",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                ></button>
              </Link>
            </div>
            <Divider
              style={{
                borderColor: "white ",
                margin: "15px 0",
                position: "absolute",
                bottom: "0",
                width: "100%",
              }}
            />
          </div>
        </Card>
        <div>
          <div className="call-info">
            <MyLink
              href="mailto:taim.jaber.dev@gmail.com"
              target="_blank"
              underline="none"
            >
              <span>taim.jaber.dev@gmail.com</span>
            </MyLink>
            <MyLink href="tel:+963996621746" target="_blank" underline="none">
              <span>+963 996 621 746</span>
            </MyLink>
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  );
}
